import React, { memo, useState } from 'react'
import { useSelector } from 'react-redux'
import { Card } from 'primereact/card'

import { RootState } from '../../redux/store'
import { MeasurementDevicesTableWidget } from '../../../common/features/measurement-device/measurement-devices-table-widget'
import { PageLayoutContainer } from '../../../lib/page-layout-container'
import { MeasurementDeviceSearchListForm } from '../../../common/features/measurement-device/measurement-device-search-list-form'
import {
    MeasurementDevicesGetFilteredApiArg,
    MeasurementDevicesGetFilteredPagedApiArg,
    useMeasurementDevicesGetFilteredPagedQuery,
} from '../../../common/redux/api/web-api'

export type MeasurementDevicesPageProps = {
    style?: React.CSSProperties
}

export const MeasurementDevicesPage = memo(function MeasurementDevicesPage({
    style,
}: MeasurementDevicesPageProps): React.ReactElement {
    const user = useSelector((state: RootState) => state.user)

    const defaultFiltersValue: MeasurementDevicesGetFilteredPagedApiArg = {
        serialNumber: '',
        companyId: user?.selectedCompanyId,
        name: '',
        companyName: '',
        partnerName: '',
        page: 0,
        noOfItems: 15,
    }

    const [filter, setFilter] = useState<MeasurementDevicesGetFilteredPagedApiArg>(defaultFiltersValue)

    const handleFilterSubmit = (filters: MeasurementDevicesGetFilteredApiArg) => {
        setFilter({ ...defaultFiltersValue, ...filters })
    }

    const { currentData: measurementDeviceData, isFetching: isLoading } = useMeasurementDevicesGetFilteredPagedQuery(
        filter,
        {
            refetchOnMountOrArgChange: true,
            skip: !user?.selectedCompanyId,
        }
    )

    const clearDevices = () => {
        setFilter(defaultFiltersValue)
    }

    return (
        <PageLayoutContainer style={style}>
            <Card>
                <MeasurementDeviceSearchListForm
                    onSubmit={handleFilterSubmit}
                    clearDevice={clearDevices}
                    isLoading={isLoading}
                />

                <MeasurementDevicesTableWidget
                    data={measurementDeviceData!}
                    isLoading={isLoading}
                    filter={filter}
                    setFilter={setFilter}
                />
            </Card>
        </PageLayoutContainer>
    )
})
